<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="noticeOrigin" [cdkConnectedOverlayOpen]="!!notice"
  [cdkConnectedOverlayPositions]="noticePositions" [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayViewportMargin]="8">
  <p class="operation-notice" role="status">{{ notice }}</p>
</ng-template>
<div class="dialog-heading" [class.success-heading]="state.status === 'verified'" cdkOverlayOrigin #noticeOrigin="cdkOverlayOrigin">
  <h2 mat-dialog-title *ngIf="state.status !== 'verified'">
    <ng-container *ngIf="state.status === 'confirm'; else entryTitle">
      {{ isPhone ? '¿Te enviamos el código a este número?' : '¿Te enviamos el código a este email?' }}
    </ng-container>
    <ng-template #entryTitle>Ingresá el código de verificación</ng-template>
  </h2>
  <button mat-icon-button mat-dialog-close class="otp-close-button" [disableRipple]="true" type="button" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content [attr.aria-busy]="busy">
  <ng-container *ngIf="state.status === 'confirm'; else verification">
    <p class="confirmation-description">{{ isPhone ? 'Verificá que el número de teléfono sea correcto.' : 'Verificá que el email esté bien escrito.' }}</p>
    <div class="recipient confirmation-recipient">
      <ng-container *ngIf="isPhone && state.phoneDisplay as phone; else plainRecipient">
        <img class="phone-flag" [src]="'assets/media/countriesFlags/' + phone.country + '.webp'" [alt]="phone.countryLabel">
        <span class="country-code">{{ phone.countryCode }}</span>
        <span>{{ phone.nationalNumber }}</span>
      </ng-container>
      <ng-template #plainRecipient>{{ state.recipient }}</ng-template>
    </div>
  </ng-container>

  <ng-template #verification>
    <ng-container *ngIf="state.status !== 'verified'; else success">
      <p class="delivery-description" role="status">Enviamos un código por {{ deliveryLabel }} a<br>
        <strong class="recipient">{{ displayedRecipient }}</strong>
        <button mat-button class="edit-contact-button" type="button" [disabled]="busy" (click)="edit()">Editar</button>
      </p>
      <div [formGroup]="codeForm">
        <label id="otp-label" class="cdk-visually-hidden">Código de 6 caracteres</label>
        <div class="code-inputs" role="group" aria-labelledby="otp-label">
          <input #codeInput *ngFor="let digit of digits" class="code-input" type="text"
            inputmode="text" pattern="[a-zA-Z0-9]" maxlength="1" autocomplete="off"
            autocapitalize="off" [spellcheck]="false"
            [formControlName]="'code' + digit" [attr.aria-label]="'Carácter ' + (digit + 1)"
            [attr.aria-invalid]="state.status === 'incorrect' || state.status === 'blocked'"
            [class.input__invalid]="state.status === 'incorrect' || state.status === 'blocked' || (submitted && codeForm.invalid)"
            (input)="onInput(digit)" (keydown)="onKeydown($event, digit)" (paste)="onPaste($event)">
        </div>
        <div aria-live="polite">
          <p class="warning-label" *ngIf="submitted && codeForm.invalid">Ingresá los 6 caracteres del código recibido.</p>
          <p class="warning-label" *ngIf="state.status === 'incorrect'">
            El código no es correcto.<ng-container *ngIf="state.remainingAttempts !== undefined">
              Te {{ state.remainingAttempts === 1 ? 'queda' : 'quedan' }} {{ state.remainingAttempts }} {{ state.remainingAttempts === 1 ? 'intento' : 'intentos' }}.</ng-container>
          </p>
          <p class="warning-label" *ngIf="state.status === 'blocked'">Superaste los intentos. Pedí un código nuevo para seguir.</p>
          <p class="warning-label" *ngIf="state.status === 'expired'">El código venció. Solicitá uno nuevo para continuar.</p>
        </div>
        <p class="expiration-text" *ngIf="state.status === 'code' && expiresIn > 0">El código vence en {{ config.expirationMinutes }} minutos.</p>
        <p class="resend-text" *ngIf="resendIn > 0 && !resending">Podés pedir otro código en {{ formatTime(resendIn) }}</p>
        <button *ngIf="canResend || resending" mat-button class="resend-action" type="button" [disabled]="!canResend" [attr.aria-busy]="resending" (click)="resend()">
          Reenviar código
        </button>
      </div>
    </ng-container>
    <ng-template #success>
      <div class="verified" role="status">
        <div class="success-icon"><mat-icon>check</mat-icon></div>
        <h2 mat-dialog-title>{{ isPhone ? 'Celular verificado' : 'Email verificado' }}</h2>
        <p>{{ isPhone ? 'Te vamos a avisar de tus entregas a este número.' : 'Te vamos a enviar tus comprobantes y novedades acá.' }}</p>
      </div>
    </ng-template>
  </ng-template>
  <p *ngIf="error" class="warning-label" role="alert">{{ error }}</p>
</mat-dialog-content>

<mat-dialog-actions *ngIf="state.status === 'confirm'" class="confirmation-actions">
  <button mat-raised-button class="next-button" type="button" [disabled]="busy" (click)="send()">Sí, enviar código</button>
  <button mat-button class="update-contact-button" type="button" [disabled]="busy" (click)="edit()">{{ isPhone ? 'Actualizar número' : 'Actualizar email' }}</button>
</mat-dialog-actions>

<mat-dialog-actions *ngIf="state.status !== 'confirm'" class="verify-action">
  <button mat-raised-button class="next-button" type="button" [disabled]="state.status !== 'verified' || busy"
    [attr.aria-busy]="validating" aria-live="polite" (click)="complete()">
    <span class="verify-button-content">
      <span *ngIf="validating" class="verification-spinner" aria-hidden="true"></span>
      {{ validating ? 'Verificando' : 'Continuar' }}
    </span>
  </button>
</mat-dialog-actions>
